import React from "react";
import { useNavigate } from "react-router-dom";
import { imageSrc } from "../../../utils/imageUrl";

interface Soulmate {
  _id: string;
  displayName?: string;
  userName?: string;
  profileImgUrl?: string;
  matchScore: number;
  totalSharedQuestions: number;
  matchingAnswers: number;
}

interface SoulmateCardProps {
  soulmate: Soulmate;
}

export const SoulmateCard: React.FC<SoulmateCardProps> = ({ soulmate }) => {
  const navigate = useNavigate();

  const handleProfileClick = () => {
    navigate(`/profile/${soulmate._id}`);
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-6 cursor-pointer border border-gray-200"
      onClick={handleProfileClick}
    >
      <div className="flex flex-col items-center text-center">
        {/* Profile Image */}
        <div className="w-16 h-16 mb-4">
          {soulmate.profileImgUrl ? (
            <img
              src={imageSrc(soulmate.profileImgUrl, 'thumb')}
              alt={soulmate.displayName || soulmate.userName}
              className="w-full h-full rounded-full object-cover"
            />
          ) : (
            <div className="w-full h-full rounded-full bg-gradient-to-br from-purple-400 to-pink-400 flex items-center justify-center text-white font-semibold text-lg">
              {(soulmate.displayName || soulmate.userName || 'U').charAt(0).toUpperCase()}
            </div>
          )}
        </div>

        {/* User Info */}
        <h3 className="font-semibold text-lg text-gray-900 mb-1">
          {soulmate.displayName || soulmate.userName || 'Unknown User'}
        </h3>
        
        {soulmate.userName && soulmate.displayName && (
          <p className="text-sm text-gray-500 mb-3">
            @{soulmate.userName}
          </p>
        )}

        {/* Match Score */}
        <div className="mb-4">
          <div className="text-2xl font-bold text-purple-600 mb-1">
            {soulmate.matchScore}%
          </div>
          <div className="text-xs text-gray-500">
            Compatibility
          </div>
        </div>

        {/* Match Details */}
        <div className="text-xs text-gray-600 bg-gray-50 rounded-lg p-3 w-full">
          <div className="flex justify-between items-center">
            <span>Shared Questions:</span>
            <span className="font-medium">{soulmate.totalSharedQuestions}</span>
          </div>
          <div className="flex justify-between items-center mt-1">
            <span>Matching Answers:</span>
            <span className="font-medium">{soulmate.matchingAnswers}</span>
          </div>
        </div>

        {/* Action Button */}
        <button 
          className="mt-4 w-full bg-purple-600 hover:bg-purple-700 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200 text-sm"
          onClick={(e) => {
            e.stopPropagation();
            handleProfileClick();
          }}
        >
          View Profile
        </button>
      </div>
    </div>
  );
};